module.exports = __webpack_public_path__ + "img/location-2-ended.986217e9.png";